import { useEffect } from "react";
import { useFirebaseContext } from "context";
import { onAuthStateChanged } from "firebase/auth";
import { LOGIN } from "navigation/constants";
import { useNavigate } from "react-router-dom";

const useLoginCheck = () => {
  const navigate = useNavigate();
  const { auth } = useFirebaseContext();

  useEffect(() => {
    if (
      !window.location.href.includes("order") &&
      !window.location.href.includes("invitation") &&
      !window.location.href.includes("admin")
    ) {
      onAuthStateChanged(auth, function (user) {
        if (!user) {
          navigate(LOGIN);
        }
      });
    }
  }, [navigate]);
};

export default useLoginCheck;
